import {useState} from "react";
import {
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Popover,
    Select,
} from "@mui/material";
import {observer} from "mobx-react-lite";
import {DateTime} from "luxon";
//import dateRangeStyles from "./FilterBarDateRange.module.scss";
import "./dateRangeFilter.scss";

import styles from "../filter/filterbar.module.scss";

import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import dayjs, {Dayjs} from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {renderTimeViewClock} from "@mui/x-date-pickers/timeViewRenderers";
import {DateRange} from "react-date-range";
import {addDays} from "date-fns";
import {
    Box,

    Typography,
    Paper,


} from "@mui/material";


interface DateRangeFilterProps {
    date: { startDate: DateTime; endDate: DateTime; key: string; label: string };
    setDate: (newDate: {
        startDate: DateTime;
        endDate: DateTime;
        key: string;
        label: string;
    }) => void;
}

const FilterBarDateRange = ({date, setDate}: DateRangeFilterProps) => {
    const [openPopover, setOpenPopover] = useState(false);
    const [startTime, setStartTime] = useState<Dayjs | null>(
        dayjs("2022-04-17T00:00")
    );
    const [endTime, setEndTime] = useState<Dayjs | null>(
        dayjs("2022-04-17T23:59")
    );
    return (
        <div className={styles.filterGroup}>
            <FormControl className={styles.filterGroup}
                         data-testid={"date-filter"}
                         required={true}
                         fullWidth
                         variant="standard"
            >

                <Typography className={styles.filterLabel}>Time Frame</Typography>
                <Select
                    sx={{
                        "& .MuiSelect-select": {
                            backgroundColor: "#FFFFFF", // Default color to remove any unwanted overlay
                        },
                        "&.Mui-focused .MuiSelect-select": {
                            backgroundColor: "#FFFFFF", // Change background when focused
                        },
                    }}

                    value={date.label} disableUnderline={true} required={true} className={styles.filterSelect}
                    IconComponent={ExpandMoreRoundedIcon}>
                    <MenuItem disabled value=""
                              className={styles.menuItem}>
                        <em>Date Range</em>
                    </MenuItem>
                    <MenuItem className={styles.menuItem}
                              value={"Custom Date Range"}
                              onClick={() => setOpenPopover(true)}
                    >
                        Custom Date Range
                    </MenuItem>
                    <MenuItem className={styles.menuItem}
                              data-testid={"date-filter-today"}
                              value={"Today"}
                              onClick={() =>
                                  setDate({
                                      ...date,
                                      label: "Today",
                                      startDate: DateTime.now().startOf("day"),
                                      endDate: DateTime.now(),
                                  })
                              }
                    >
                        Today
                    </MenuItem>
                    <MenuItem className={styles.menuItem}
                              data-testid={"date-filter-yesterday"}
                              value={"Yesterday"}
                              onClick={() =>
                                  setDate({
                                      ...date,
                                      label: "Yesterday",
                                      startDate: DateTime.now().minus({days: 1}).startOf("day"),
                                      endDate: DateTime.now().minus({days: 1}).endOf("day"),
                                  })
                              }
                    >
                        Yesterday
                    </MenuItem>
                    <MenuItem className={styles.menuItem}
                              data-testid={"date-filter-last3"}
                              value={"Last 3 Days"}
                              onClick={() =>
                                  setDate({
                                      ...date,
                                      label: "Last 3 Days",
                                      startDate: DateTime.now().startOf("day").minus({days: 3}),
                                      endDate: DateTime.now(),
                                  })
                              }
                    >
                        Last 3 Days
                    </MenuItem>
                    <MenuItem className={styles.menuItem}
                              data-testid={"date-filter-last7"}
                              value={"Last 7 Days"}
                              onClick={() =>
                                  setDate({
                                      ...date,
                                      label: "Last 7 Days",
                                      startDate: DateTime.now().startOf("day").minus({days: 7}),
                                      endDate: DateTime.now(),
                                  })
                              }
                    >
                        Last 7 Days
                    </MenuItem>
                </Select>

                <Popover
                    open={openPopover}
                    onClose={() => setOpenPopover(false)}
                    anchorReference={"none"}
                    className={'popoverRoot'}
                >
                    <div className={'dateRangeWrapper'}>
                        <DateRange
                            onChange={(item) => {

                                setDate({
                                    ...date,
                                    startDate: DateTime.fromJSDate(
                                        item.selection.startDate as Date
                                    ),
                                    endDate: DateTime.fromJSDate(
                                        item.selection.endDate as Date
                                    ).endOf("day"),
                                    label: "Custom Date Range",
                                });
                                setStartTime(dayjs("2022-04-17T00:00"));
                                setEndTime(dayjs("2022-04-17T23:59"));
                            }}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            minDate={addDays(new Date(), -600)}
                            maxDate={new Date()}
                            direction={"horizontal"}
                            scroll={{enabled: false, calendarHeight: 100, calendarWidth: 400}}
                            ranges={[
                                {
                                    startDate: date.startDate.toJSDate(),
                                    endDate: date.endDate.toJSDate(),
                                    key: "selection",
                                },
                            ]}
                        />
                        <div className={'timeContainer'}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label={"from hh:mm"}
                                    viewRenderers={{
                                        hours: renderTimeViewClock,
                                        minutes: renderTimeViewClock,
                                    }}
                                    value={startTime}
                                    onChange={(newValue) => {
                                        setStartTime(newValue);
                                        setDate({
                                            ...date,
                                            startDate: date.startDate.set({
                                                hour: newValue?.hour(),
                                                minute: newValue?.minute(),
                                            }),
                                        });
                                    }}
                                />
                                <TimePicker
                                    label={"to hh:mm"}
                                    viewRenderers={{
                                        hours: renderTimeViewClock,
                                        minutes: renderTimeViewClock,
                                    }}
                                    value={endTime}
                                    onChange={(newValue) => {
                                        setEndTime(newValue);
                                        setDate({
                                            ...date,
                                            endDate: date.endDate.set({
                                                hour: newValue?.hour(),
                                                minute: newValue?.minute(),
                                            }),
                                        });
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                       {/* <IconButton
                            sx={{
    background: "rgb(244, 67, 54) !important",
    color: "#fff",
        borderRadius:0,
    "&:hover": {
      background: "rgb(244, 67, 54) !important",

    },
  }}
                          onClick={() => setOpenPopover(false)}>
                            Close
                        </IconButton>
                        */}
                           <Button
                                sx={{
    background: "rgb(244, 67, 54) !important",
    color: "#fff",
        borderRadius:0,
    "&:hover": {
      background: "rgb(244, 67, 54) !important",

    },
  }}
                               variant={"contained"} onClick={() => setOpenPopover(false)}>
                            Close
                        </Button>
                    </div>
                </Popover>

            </FormControl>
        </div>
    );
};

export default observer(FilterBarDateRange);
